import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { refreshLikedIds, clearLikedIds } from "../lib/likes";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("kmu_token");
    if (!token) {
      setChecking(false);
      return;
    }
    api.get("/auth/me")
      .then((res) => { setUser(res.data); refreshLikedIds(); })
      .catch(() => localStorage.removeItem("kmu_token"))
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("kmu_token", res.data.token);
    setUser(res.data.user);
    refreshLikedIds();
    return res.data.user;
  };

  const signup = async (payload) => {
    const res = await api.post("/auth/signup", payload);
    localStorage.setItem("kmu_token", res.data.token);
    setUser(res.data.user);
    refreshLikedIds();
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("kmu_token");
    setUser(null);
    clearLikedIds();
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, signup, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
